// extracted by mini-css-extract-plugin
module.exports = {"Quantity":"Styles_Quantity__5f9xM","CardRow":"Styles_CardRow__1hWr3"};